<script setup lang="ts">
import { STREAM_BASE_URI } from '@/js/constants';
</script>

<template>
<!---
  NOTE: 用 iframe 是因為 CMS 是嵌入在客戶的網站，網址是別人的，不應該因我們系統維護中就把網址轉走
-->
<div class="page-maintenance-state">
  <iframe :src="STREAM_BASE_URI" frameborder="0" width="100%" height="1024px"></iframe>
</div>
</template>
<style lang="scss" scoped>
.page-maintenance-state {
  /* nothing to do */
}
</style>
